import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import m from '@utils/strings';

const AjaxLoader = (props) => (
  <div>
    <Dimmer active inverted style={{ position: "fixed" }}>
      <Loader inverted>{props.ajaxMessage ? props.ajaxMessage : m.GERAL.MENSAGEM_LOADER_VERIFICANDO}</Loader>
    </Dimmer>
  </div>
)

export default AjaxLoader